import { render, staticRenderFns } from "./color-tone.vue?vue&type=template&id=0bb61088&"
import script from "./color-tone.vue?vue&type=script&lang=ts&"
export * from "./color-tone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb61088')) {
      api.createRecord('0bb61088', component.options)
    } else {
      api.reload('0bb61088', component.options)
    }
    module.hot.accept("./color-tone.vue?vue&type=template&id=0bb61088&", function () {
      api.rerender('0bb61088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-page/color-tone.vue"
export default component.exports